export default __webpack_public_path__ + "static/media/white-choc.89342a5a.jpg";